import classNames from 'classnames'
import React from 'react'
import { Col, Row } from '../react-bootstrap'
import U from '../Utils'
import './RowTotali.css'

function RowTotali(props) {
  let { series, data } = props
  let { totali } = data

  let numeri = [
    {
      key: 'assunzioni',
      name: 'Totale assunzioni',
      formatter: U.formatNumber,
    },
    {
      key: 'saldo',
      name: 'Saldo occupazionale',
      formatter: U.formatNumberPlus,
    },
    {
      key: 'saldo_cti',
      name: 'Tempo indeterminato',
      formatter: U.formatNumberPlus,
    },
  ]

  return (
    <Row className="RowTotali">
      {numeri.map((num, n) => (
        <Col sm={4} key={n} className="RowTotali-totale">
          {series.map((ser, s) => (
            <p key={s} className={classNames({ double: ser.name })}>
              <span className="RowTotali-col number">
                {num.formatter(totali[num.key + ser.suf])}
              </span>
              {ser.name && <span className="RowTotali-col name">{ser.name}</span>}
            </p>
          ))}
          <span>{num.name}</span>
        </Col>
      ))}
    </Row>
  )
}

export default RowTotali



// WEBPACK FOOTER //
// ./src/main/RowTotali.js